import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, Routes} from '@angular/router';
import {MainLayoutComponent} from './layout/main-layout/main-layout.component';
import {TestLayoutComponent} from './layout/test-layout/test-layout.component';
import { AccountGridComponent } from './views/account-grid/account-grid.component';
import {UserDetailsComponent} from './views/user-details/user-details.component';
import {PortfolioArchiveComponent} from './views/portfolio-archive/portfolio-archive.component';
import {HomeComponent} from './views/home/home.component';
import {SegmentChecksComponent} from './views/segment-checks/segment-checks.component';
import {PortfolioConfigDataComponent} from './views/portfolio-config-data/portfolio-config-data.component';
import {PortfolioConfigFxratesComponent} from './views/portfolio-config-fxrates/portfolio-config-fxrates.component';
import {PortfolioConfigKpisComponent} from './views/portfolio-config-kpis/portfolio-config-kpis.component';
import {AppDeveloperToolsComponent} from './views/app-developer-tools/app-developer-tools.component';
import {PortfolioMembersComponent} from './views/portfolio-members/portfolio-members.component';
import {
    PortfolioContextResolverComponent,
    PortfolioSegmentContextResolverComponent
} from './data/portfolio-context-resolver.service';
import {inject} from '@angular/core';
import { PortfolioSegmentDataContext } from './data/portfolio-segment-data-context.service';
import {TestDialogsComponent} from './test/test-dialogs/test-dialogs.component';
import {TestControlsComponent} from './test/test-controls.component';
import {TestFlexGridLayoutComponent} from './test/test-flexgrid-layout.component';
import {TestComponentTooltipComponent} from './test/test-component-tooltip.component';
import {TestMonacoComponent} from './test/test-monaco.component';
import {TestViewEditorComponent} from './test/test-view-editor.component';
import {DashboardTargetsMainComponent} from './views/dashboard-targets-main/dashboard-targets-main.component';
import {TestFluentDatagrid} from './test/test-fluent-datagrid.component';
import {DashboardTrackingMainComponent} from './views/dashboard-tracking-main/dashboard-tracking-main.component';
import {DashboardVolatilityComponent} from './views/dashboard-volatility/dashboard-volatility.component';
import {PfReportTargetsComponent} from './views/pf-report-targets/pf-report-targets.component';
import {PfReportTrackingComponent} from './views/pf-report-tracking/pf-report-tracking.component';
import {AppDevAccountSheetComponent} from './views/app-dev-account-sheet/app-dev-account-sheet.component';
import {TestWijmoSheetComponent} from './test/test-wijmo-sheet.component';
import {ExternalReportViewerComponent} from './components/external-report-viewer/external-report-viewer.component';
import {TestSignalsComponent} from './test/test-signals.component';
import {SegmentOverviewComponent} from './views/segment-overview/segment-overview.component';
import {AdminUsersComponent} from './views/admin-users/admin-users.component';
import {TestUserAdminComponent} from './test/test-user-admin.component';
import {TestCommentEditorComponent} from './test/test-comments-editor.component';
import {TestAtsScatterChartComponent} from './test/test-ats-scatter-chart.component';
import {TestWaterfallChartComponent} from './test/test-waterfall-chart.component';
import {SegmentStatusComponent} from './views/segment-status/segment-status.component';
import {TestOpaWasmComponent} from './test/test-opa-wasm.component';
import {TestAccountCommentsEditorComponent} from './test/test-account-comments-editor.component';
import { TestConfigMatrixComponent } from "./test/test-config-matrix.component";

function doNotLeaveWhenDataDirtyGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const pfsegData = inject(PortfolioSegmentDataContext);
        return true;
    };
}

export const routes: Routes = [
    { path: '', redirectTo: '/app/home', pathMatch: 'full' },
    { path: 'app', component: MainLayoutComponent, children: [
            { path: 'home', component: HomeComponent } ,
            { path: 'archive', component: PortfolioArchiveComponent },
            { path: 'userdetails', component: UserDetailsComponent },
            { path: 'devtools', component: AppDeveloperToolsComponent },

            { path: 'pfm/:pfid', component: PortfolioContextResolverComponent, children: [
                    { path: 'config/lrdata', component: PortfolioConfigDataComponent },
                    { path: 'config/kpis', component: PortfolioConfigKpisComponent },
                    { path: 'config/fxrates', component: PortfolioConfigFxratesComponent },
                    { path: 'members', component: PortfolioMembersComponent },
                    { path: 'devtools', component: AppDeveloperToolsComponent },
                    { path: 'appusers', component: AdminUsersComponent},

                    { path: 'segment/:segmentId', component: PortfolioSegmentContextResolverComponent, children: [
                            { path: 'config/lrdata', component: PortfolioConfigDataComponent },
                            { path: 'config/kpis', component: PortfolioConfigKpisComponent },
                            { path: 'config/fxrates', component: PortfolioConfigFxratesComponent },
                            { path: 'overview', component: SegmentOverviewComponent },
                            { path: 'accounts', component: AccountGridComponent },
                            { path: 'checks', component: SegmentChecksComponent },
                            { path: 'status', component: SegmentStatusComponent },
                            { path: 'dashboard/targets', component: DashboardTargetsMainComponent },
                            { path: 'dashboard/tracking', component: DashboardTrackingMainComponent },
                            { path: 'dashboard/volatility', component: DashboardVolatilityComponent },
                            { path: 'report/targets', component: PfReportTargetsComponent },
                            { path: 'report/tracking', component: PfReportTrackingComponent },
                            { path: 'dev/sheet', component: AppDevAccountSheetComponent },
                            { path: 'devtools', component: AppDeveloperToolsComponent },

                            { path: 'xrep/uwstatus', component: ExternalReportViewerComponent,
                                data: { config: { reportUrl: 'http://localhost:8000/reports/uw-status' } } },
                            { path: 'xrep/uwstrategy', component: ExternalReportViewerComponent,
                                data: { config: { reportUrl: 'http://localhost:8000/reports/uw-strategy' } } }
                        ]
                    }
                ]},
            { path: 'users', component: AdminUsersComponent},
        ]
    },

    { path: 'test', component: TestLayoutComponent, children: [
            { path: 'home', component: HomeComponent },
            { path: 'accountgrid', component: AccountGridComponent },
            { path: 'userdetails', component: UserDetailsComponent },
            { path: 'dialogs', component: TestDialogsComponent },
            { path: 'controls', component: TestControlsComponent },
            { path: 'flexgridlayout', component: TestFlexGridLayoutComponent },
            { path: 'componenttooltip', component: TestComponentTooltipComponent },
            { path: 'monaco', component: TestMonacoComponent },
            { path: 'vieweditor', component: TestViewEditorComponent },
            { path: 'fuidatagrid', component: TestFluentDatagrid },
            { path: 'configmatrix', component: TestConfigMatrixComponent },
            { path: 'sheet', component: TestWijmoSheetComponent },
            { path: 'signals', component: TestSignalsComponent },
            { path: 'useradmin', component: TestUserAdminComponent },
            { path: 'commenteditor', component: TestCommentEditorComponent },
            { path: 'accountcommentseditor', component: TestAccountCommentsEditorComponent },
            { path: 'atsscatterchart', component: TestAtsScatterChartComponent},
            { path: 'waterfallchart', component: TestWaterfallChartComponent},
            { path: 'opa', component: TestOpaWasmComponent},
        ]
    },
];
